module.exports = __webpack_public_path__ + "static/media/gold-bar-overview.7c4906c7.png";